module.exports = __webpack_public_path__ + "969015a71468de4fa6ec0ed8a7142bf6.png";